import { useGenericSearch } from '@/hooks/useGenericSearch';
import { Job, ResourceType } from '@/types';
import { sToMs } from '@/utils/date.util';

export function useGetDownloads(options?: {
  enabled?: boolean;
  refetchInterval?: number | false;
}) {
  const result = useGenericSearch(
    {
      label: ResourceType.Job,
      query: 'source:export',
    },
    { refetchInterval: options?.refetchInterval ?? sToMs(5), ...options }
  );

  return {
    ...result,
    data: (result.data?.jobs ?? []) as Job[],
  };
}
